module.exports = __webpack_public_path__ + "media/assets/icons/exit-d83a5c5b246a121cda79e2e2e0618955.svg";